import {
  Button,
  FormControl,
  FormHelperText,
  makeStyles,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import MessagePanel from "../../components/messagePanel";
import { authActions } from "../../store/actions/auth.actions";
import { IDRaksStore } from "../../store/store";
import { DaneOsobiste } from "../../store/types/auth";
import { DaneOsobistePageStyle } from "../../styles/DaneOsobistePageStyle";
import AlertDialog from "../../components/alertDialog";
import NavigationPrompt from "react-router-navigation-prompt";

interface DaneOsobistePageProps {
  error: string;
  onGetData: Function;
  onClearError: Function;
  onSave: Function;
  onResendConfirmationEmail: Function;
  onGetSessionData: Function;
  isEmailConfirmed: boolean;
  onDeleteAccount: Function;
  onLogout: Function;
}

const DaneOsobistePage = (props: DaneOsobistePageProps) => {
  const {
    error,
    onGetData,
    onClearError,
    onSave,
    onResendConfirmationEmail,
    isEmailConfirmed,
    onGetSessionData,
    onDeleteAccount,
    onLogout,
  } = props;
  const [dane, setDane] = useState({} as DaneOsobiste);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    onGetSessionData();
    onGetData().then((dto: DaneOsobiste) => {
      if (dto) setDane(dto);
    });
    return () => {
      onClearError();
    };
    // eslint-disable-next-line
  }, []);

  function save() {
    setDirty(false);
    onSave(dane.Imie, dane.Nazwisko);
  }

  function deleteAccount() {
    setPasswordError(!password ? "Pole wymagane" : "");
    if (password)
      onDeleteAccount(password).then((res: boolean) => {
        if (res) onLogout();
      });
  }

  const useStyles = makeStyles({
    input: {
      fontFamily: "text-security-disc",
    },
  });

  const classes = useStyles();

  return (
    <DaneOsobistePageStyle>
      <header>
        <h5>Dane osobiste</h5>
        <Button
          name="btnZapisz"
          color="secondary"
          variant="contained"
          onClick={save}
        >
          ZAPISZ
        </Button>
      </header>
      <>
        {error !== "" && (
          <MessagePanel mode="error" title="Błąd!" message={error} />
        )}
        <div className="panel">
          <section>
            <form className="panel__dane" onChange={(e) => setDirty(true)}>
              <FormControl>
                <TextField
                  name="Imie"
                  value={dane.Imie || ""}
                  onChange={(e) => setDane({ ...dane, Imie: e.target.value })}
                  label="Imię"
                />
              </FormControl>
              <FormControl>
                <TextField
                  name="Nazwisko"
                  value={dane.Nazwisko || ""}
                  onChange={(e) =>
                    setDane({ ...dane, Nazwisko: e.target.value })
                  }
                  label="Nazwisko"
                />
              </FormControl>
            </form>
          </section>

          {!isEmailConfirmed && (
            <section>
              <div className="panel__potwierdz">
                <h6 className="disabled">POTWIERDZENIE KONTA</h6>
                <div className="medium body1 opis">
                  Twoje konto nie zostało jeszcze potwierdzone. Do czasu pełnej
                  weryfikacji konta niektóre funkcje programu mogą być
                  niedostępne.
                </div>
                <div className="medium body1 opis">
                  Podczas rejestracji wysłaliśmy do Ciebie e-mail aktywacyjny z
                  linkiem do potwierdzenia konta. Jeśli jednak wspomniany e-mail
                  zaginął, został omyłkowo skasowany lub wygasła ważność linku
                  aktywacyjnego, możesz wysłać go ponownie.
                </div>
                <div className="panel__potwierdz__buttons">
                  <Button
                    name="btnCancel"
                    color="secondary"
                    variant="text"
                    onClick={() => {
                      onResendConfirmationEmail();
                    }}
                  >
                    WYŚLIJ E-MAIL AKTYWACYJNY
                  </Button>
                </div>
              </div>
            </section>
          )}
          <section>
            <div className="panel__usun">
              <h6 className="disabled">USUWANIE KONTA</h6>
              <div className="medium body1 opis">
                W tym miejscu możesz usunąć swoje konto w programie. Skasowaniu
                ulegną wszystkie dane Twojej firmy, a także Twój profil
                użytkownika.
              </div>
              {!deleteVisible && (
                <div className="panel__usun__buttons1">
                  <Button
                    name="btnDeleteVisible"
                    color="secondary"
                    variant="text"
                    onClick={() => {
                      setPasswordError("");
                      setDeleteVisible(true);
                    }}
                  >
                    ROZUMIEM, CHCĘ KONTYNUOWAĆ
                  </Button>
                </div>
              )}
              {deleteVisible && (
                <div className="panel__usun__etap2">
                  <MessagePanel
                    title="Ostrzeżenie!"
                    mode="warning"
                    message="Operacja usunięcia konta jest nieodwracalna. Stracisz wszystkie swoje dane!"
                  />
                  <div className="medium body1">
                    Aby zapobiec przypadkowemu lub nieautoryzowanemu usunięciu
                    konta, prosimy - potwierdź tę operację poprzez podanie
                    hasła.
                  </div>
                  <FormControl error={passwordError !== ""}>
                    <TextField
                      tc-data="password"
                      value={password || ""}
                      onChange={(e) => setPassword(e.target.value)}
                      label="Hasło"
                      InputProps={{ classes: { input: classes.input } }}
                    />
                    {passwordError && (
                      <FormHelperText id="password-error-text">
                        {passwordError}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <div className="panel__usun__buttons2">
                    <Button
                      name="btnDelete"
                      color="secondary"
                      variant="outlined"
                      onClick={() => deleteAccount()}
                    >
                      USUŃ KONTO
                    </Button>
                    <Button
                      name="btnCancel"
                      color="secondary"
                      variant="outlined"
                      onClick={() => {
                        setPassword("");
                        onClearError();
                        setDeleteVisible(false);
                      }}
                    >
                      ANULUJ
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </>
      <NavigationPrompt
        when={(crntLocation, nextLocation) => nextLocation != null && dirty}
      >
        {({ onConfirm, onCancel }) => (
          <AlertDialog
            title="Potwierdzenie"
            content="Czy chcesz opuścić formularz bez zapisywania danych?"
            mode="YesNo"
            onAccept={onConfirm}
            onCancel={onCancel}
          />
        )}
      </NavigationPrompt>
    </DaneOsobistePageStyle>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.auth.error,
    isEmailConfirmed: store.auth.isEmailConfirmed,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onGetData: () => {
      return dispatch(authActions.getPersonalData());
    },
    onSave: (imie: string, nazwisko: string) => {
      return dispatch(authActions.changePersonalData(imie, nazwisko));
    },
    onResendConfirmationEmail: () => {
      return dispatch(authActions.resendConfirmationEmail());
    },
    onClearError: () => dispatch(authActions.clearError()),
    onGetSessionData: () => dispatch(authActions.getSessionData()),
    onDeleteAccount: (password: string) => {
      return dispatch(authActions.deleteAccount(password));
    },
    onLogout: () => dispatch(authActions.logout()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DaneOsobistePage);
